import React from "react";

import { Event } from "lib/build/events";

import { useFormatFsn } from "src/common/hooks/useFormatFsn";

export function useTagOptions(
	events: Event[]
): { label: string; value: string }[] {
	const formatFsn = useFormatFsn();
	return React.useMemo(() => {
		const map = new Map<string, string>();
		for (const { tagDetails } of events) {
			for (const tag of tagDetails) {
				map.set(`${tag.vocab}|${tag.code}`, formatFsn(tag));
			}
		}
		return Array.from(map.entries()).map(([value, label]) => ({
			label,
			value
		}));
	}, [events, formatFsn]);
}
